import { IsNotEmpty, IsNumberString } from "class-validator";

export class RoutePaginationDTO {

    @IsNotEmpty()
    @IsNumberString()
    page: string;

}
